var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100vw","height":"100vh"}},[_c('cmdp-writer-follow',{attrs:{"domain":"https://a.cmdp.cn","label":"小智仿写"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }